import type { InvitationMethod } from '@/features/client-relationships';

export const getInitials = (name: string): string => {
  const parts = name.trim().split(' ');
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const formatRelativeDate = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
  return `${Math.floor(diffDays / 30)} months ago`;
};

export const formatCooldownTime = (seconds: number): string => {
  if (seconds <= 0) return '';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (mins === 0) return `${secs}s`;
  return `${mins}m ${secs}s`;
};

/** Human-readable label for each invitation method */
const INVITATION_METHOD_LABELS: Record<InvitationMethod, string> = {
  EMAIL_INVITE: 'Email Invite',
  REFERRAL_CODE: 'Referral Code',
  PARTNER_REFERRAL_CODE: 'Partner Referral',
  ENGAGEMENT_ACCEPTANCE: 'Engagement',
};

export const formatInvitationMethod = (method: InvitationMethod): string =>
  INVITATION_METHOD_LABELS[method] ?? method;
